import { InputBase } from "./_InputBase";

/**
 * Controller for Duration edit input
 */

export class InputDurationController extends InputBase<string> {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [];

  public innerValue: {
    /** If true, the duration is negative, meaning "before" the reference time. */
    isNegative: boolean,
    /** Integer number of days. */
    days: number,
    /** Rest of the duration is just kept if it exists. It cannot be edited at the moment. */
    rest: string,
  };

  /**
   * Creates a new InputController
   * @ignore
   */
  constructor() {
    super();
  }

  /** Set the values and defaults on init */
  public $onInit() {
    if (this.name && !this.label) {
      this.label = this.name;
    }
    this.model.$render = () => {
      this.value = this.model.$viewValue;
      this.setInnerValue(this.model.$viewValue);
    };
    this.validate();
  }

  /** Called when the view changes the model. */
  public onChange() {
    this.value = this.getInnerValue();
    super.onChange();
  }

  /** Gets the inner value as string */
  public getInnerValue(): string {
    if (!this.innerValue) {
      return null;
    }
    let result = "";
    if (this.innerValue.days != null && !isNaN(this.innerValue.days)) {
      result += this.innerValue.days;
    }
    if (this.innerValue.rest) {
      if (result != "") {
        result += ".";
      }
      result += this.innerValue.rest;
    }
    if (result == "") {
      return null;
    }
    if (this.innerValue.isNegative) {
      result = "-" + result;
    }
    return result;
  }

  /** Parses an input string and sets the inner value based on it. */
  public setInnerValue(value: string) {
    value = value?.trim();
    if (!value) {
      this.innerValue = null;
      return;
    }
    this.innerValue = this.innerValue || {} as any;
    if (value[0] == "-") {
      this.innerValue.isNegative = true;
      value = value.substring(1);
    } else {
      this.innerValue.isNegative = false;
    }
    const point = value.indexOf(".");
    if (point >= 0) {
      this.innerValue.days = parseInt(value.substr(0, point)) || 0;
      this.innerValue.rest = value.substr(point + 1).trim();
    } else {
      if (value.indexOf(":") >= 0) {
        this.innerValue.days = parseInt(value) || 0;
        this.innerValue.rest = null;
      } else {
        this.innerValue.days = null;
        this.innerValue.rest = value.trim();
      }
    }
  }
}
